
  import { Vue, Prop, Component, Watch } from "vue-property-decorator";

  import RadioButtonGroup from "@/components/common/RadioButtonGroup.vue";
  import FiltersContainer from "@/components/filters/filters-container.vue";
  import UiButton from "@/components/button/ui-button.vue";
  import FormGroup from "@/components/form/FormGroup.vue";
  import SkillsMultiselect from "@/components/autocompleteMultiselects/SkillsMultiselect.vue";
  import CustomRequestStatusMultiselect from "@/components/autocompleteMultiselects/CustomRequestStatusMultiselect.vue";
  import ManagersMultiselect from "@/components/autocompleteMultiselects/ManagersMultiselect.vue";
  import inputFilterDebounceTime from "@/data/inputFilterDebounceTime";
  import customRequestsFiltersTemplate from "@/data/filtersTemplates/customRequestsFiltersTemplate";

  @Component({
    components: {
      RadioButtonGroup,
      UiButton,
      FiltersContainer,
      FormGroup,
      SkillsMultiselect,
      CustomRequestStatusMultiselect,
      ManagersMultiselect,
    },
  })
  export default class CustomRequestFilters extends Vue {
    @Prop({ type: String, required: true }) readonly currentUserId!: string;
    @Prop({ type: Boolean, default: false }) readonly isAdmin!: boolean;

    jobTitle  = "";
    skillsIds: number[] = [];
    managerIds: string[] = [];
    statusIds: string[] = [];
    inputDebounceTime = inputFilterDebounceTime;

    get showManagerFilter(): boolean {
      return this.isAdmin;
    }

    get trimmedJobTitle(): string {
      return this.jobTitle.trim();
    }

    get propToWatch(): string {
      return JSON.stringify([
        this.trimmedJobTitle,
        this.skillsIds,
        this.managerIds,
        this.statusIds,
      ]);
    }

    @Watch("propToWatch")
    handlePropToWatchChange(): void {
      this.$emit("filtersChanged", {
        skillsIds: this.skillsIds,
        jobTitle: this.trimmedJobTitle,
        statusIds: this.statusIds,
        managersIds: this.managerIds,
      });
    }

    handleReset(): void {
      this.$emit("resetFilters");
      this.jobTitle = "";
      this.managerIds = [];
      this.skillsIds = [];
      this.managerIds = [];
      this.statusIds = [];
    }
  }
